module.exports = __webpack_public_path__ + "img/borderBubbleWhite.78922a17.svg";